export function getShowAds(state) {
  return state.data.ads.showAds
}

export function getAdChannel(state) {
  return state.data.ads.adChannel
}
